// slight modification of original version (special case for benefits card animation)

let intersectionObserver;

function ensureIntersectionObserver(observerOptions) {
  if (intersectionObserver) return;

  intersectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const eventName = entry.isIntersecting
          ? "enterViewport"
          : "exitViewport";
        entry.target.dispatchEvent(new CustomEvent(eventName));
      });
    },
    observerOptions //setting rootMargin bottom -50% (catching element in the middle of the screen)
  );
}

export default function viewport2(
  element,
  observerOptions = { rootMargin: "0px 0px -20% 0px", threshold: 0.5 }
) {
  ensureIntersectionObserver(observerOptions);

  intersectionObserver.observe(element);

  return {
    destroy() {
      intersectionObserver.unobserve(element);
    },
  };
}
